<template>
  <div :class="groupClass" ref="fieldGroup">
    <slot />
    <FormInputError 
      :errors="fieldErrors" 
      :custom-errors="customErrors" 
      :prevent-wrap="preventErrorWrap"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

import { getFieldErrors } from "@/func/form/validation";
import { Dict, SfFormField, SfFormFieldErrorCode } from "@/types/generalTypes";
import FormInputError from "./FormInputError.vue";

export default defineComponent({
  components: { FormInputError },
  props: {
    modelValue: Object as PropType<SfFormField>,
    allFields: { type: Object as PropType<Dict<SfFormField>> },
    customErrors: {
      type: Object as PropType<Dict<string>>,
      default: () => null,
    },
    className: { type: String, default: "sf-form-group" },
    preventErrorWrap: { type: Boolean, default: true },
  },
  data() {
    return {
      validateTimeout: null as number | null,
    };
  },
  inputTags: ["input", "select", "textarea"],
  computed: {
    fieldErrors(): SfFormFieldErrorCode[] {
      return this.modelValue && this.modelValue.errors
        ? this.modelValue.errors
        : [];
    },
    hasError(): boolean {
      return this.fieldErrors.length > 0 ? true : false;
    },
    groupClass(): string {
      const errorClass = this.hasError ? " has-error" : "";
      return this.className + errorClass;
    },
  },
  mounted() {
    for (const tag of this.$options.inputTags) {
      const elements = (
        this.$refs.fieldGroup as HTMLElement
      ).getElementsByTagName(tag);
      for (const el of elements) {
        el.addEventListener("blur", this.touchInput);
      }
    }
  },
  methods: {
    validateField() {
      if (!this.modelValue) {
        return;
      }
      const errors = getFieldErrors(this.modelValue, this.allFields);
      this.$emit("update:modelValue", {
        ...this.modelValue,
        touched: true,
        errors,
      });
      this.validateTimeout = null;
    },
    touchInput() {
      if (!this.modelValue?.touched) {
        this.validateField();
      }
    },
  },
  watch: {
    "modelValue.value"() {
      if (this.modelValue?.touched && !this.validateTimeout) {
        this.validateTimeout = setTimeout(this.validateField, 200);
      }
    },
  },
});
</script>
